module.exports = __webpack_public_path__ + "img/welcome-2.b76828a9.png";